module.exports = __webpack_public_path__ + "static/media/arrow-down.42e88aab.svg";